import { useBreadcrumbs } from '@/creditflowresearch/ui/common/hooks';
import getScorecardsBreadcrumbs from '../getScorecardBreadcrumbs';

interface IUseScorecardBreadcrumbsProps {
  companyName?: string,
  leagueType: string | string[],
  initialProductsRegionsFilters: Record<string, unknown>,
}

export const useScorecardBreadcrumbs = ({
  companyName,
  leagueType,
  initialProductsRegionsFilters,
}: IUseScorecardBreadcrumbsProps) => {
  useBreadcrumbs(
    () => {
      if (!companyName) {
        return null;
      }
      const valueLeagueType = Array.isArray(leagueType) ? leagueType[0] : leagueType;
      return getScorecardsBreadcrumbs(initialProductsRegionsFilters, valueLeagueType, companyName);
    },
    [leagueType, companyName, initialProductsRegionsFilters],
  );
};
